import { defineMessages } from 'react-intl';

export default defineMessages({
    profileDetails: {
        id: 'ml.policychange.profiledetails.Profile Details',
        defaultMessage: 'Profile Details'
    },
    baseWizardMessageNonRenters: {
        id: 'ml.policychange.profiledetails.wizardMessagePa',
        defaultMessage: 'We’ll find your {boldText} next'
    },
    profileDetailsHeader: {
        id: 'ml.policychange.profiledetails.profileDetailsHeader',
        defaultMessage: 'Tell us about your '
    },
    policyInfo: {
        id: 'ml.policychange.profiledetails.policyInfo',
        defaultMessage: 'policy info'
    },
    secondaryNamedInsuredEmail: {
        id: 'ml.policychange.profiledetails.Secondary Named Insured Email',
        defaultMessage: 'Secondary Named Insured Email'
    },
    gpaSectionHeader: {
        id: 'ml.policychange.profiledetails.gpaSectionHeader',
        defaultMessage: 'Profile Details'
    },
    savingPolicyChange: {
        id: 'ml.policychange.profiledetails.savingPolicyChange',
        defaultMessage: 'Saving policy change'
    },
    nextBaseDescription: {
        id: 'ml.policychange.profiledetails.nextBaseDescription',
        defaultMessage: 'We\'ll check if {bold} next'
    },
    nextDescriptionBold: {
        id: 'ml.policychange.profiledetails.nextDescriptionBold',
        defaultMessage: 'additional changes are needed'
    },
    makeChanges: {
        id: 'ml.policychange.profiledetails.makeChanges',
        defaultMessage: 'Make Changes'
    },
    onePhoneMustBePrimary: {
        id: 'ml.policychange.profiledetails.One phone must be a primary',
        defaultMessage: 'One phone must be a primary'
    },
    usernameLink: {
        id: 'ml.policychange.profiledetails.Click here to update your username',
        defaultMessage: 'Click here to update your username'
    },
    communicationPreferenceModalTitle: {
        id: 'ml.policychange.profiledetails.Communication preference has been changed',
        defaultMessage: 'Communication preference has been changed'
    },
    communicationPreferenceModalContinue: {
        id: 'ml.policychange.profiledetails.Continue',
        defaultMessage: 'Continue'
    },
    communicationPreferenceModalCancel: {
        id: 'ml.policychange.profiledetails.Cancel',
        defaultMessage: 'Cancel'
    },
    updatedCommPreferences: {
        id: 'ml.policychange.profiledetails.Updated Communication Preferences',
        defaultMessage: 'Updated Communication Preferences'
    },
    thisIsARequiredField: {
        id: 'ml.policychange.profiledetails.This is a required field',
        defaultMessage: 'This is a required field'
    },
    invalidEmail:{
        id:'ml.policychange.profiledetails.invalidEmail',
        defaultMessage:"Email validation services are delayed, please verify the email entered is correct, and then proceed"
    },
    EsignWarningMsg:{
        id:'ml.policychange.profiledetails.EsignWarningMsg',
        defaultMessage:"To enable eSignature delivery, please update the customer’s preference on the Customer Preference page."
    },
    requiredField: {
        id: 'ml.policychange.profiledetails.requiredField',
        defaultMessage: 'Mobile number is required when esignature options is selected as "Text"'
    },
    requiredFieldForEsignOptions: {
        id: 'ml.policychange.profiledetails.requiredFieldForEsignOptions',
        defaultMessage: 'Missing required field "eSignature Options"'
    },
    requiredFieldForEsign: {
        id: 'ml.policychange.profiledetails.requiredFieldForEsign',
        defaultMessage: ' Missing required field "eSign"'
    },
    requiredFieldEsignAck: {
        id: 'ml.policychange.profiledetails.requiredFieldEsignAck.',
        defaultMessage: 'Text Acknowledgement is required when esignature options is selected as "Text"'
    },
    missingpniEmail:{
        id: 'ml.policychange.profiledetails.missingpniEmail',
        defaultMessage: 'Primary Email is required'
    }
});
